// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/carburetor-ice-hazard.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/carburetor-ice-hazard/carburetor-ice-hazard.js';

mount([g0]);
